import { StaticImage } from "gatsby-plugin-image"
import cc from "classcat"
import useTranslations from "hooks/useTranslations"
import Divided from "components/organisms/common/Divided"
import IconCheckmark from "images/icon-checkmark-circle.svg"
import IconLock from "images/icon-lock.svg"
import List from "components/List"

const Stats = () => {
  const { helpSectionLockStats, helpSectionLockNumber } = useTranslations()
  return (
    <div className="flex h-full w-full grow items-end py-4">
      <div className="drop-shadow-xl">
        <IconLock className="mb-2 w-12 text-white md:mb-4 md:w-24" />
        <div className="text-2xl font-bold text-white md:mb-2 md:text-4xl">
          {helpSectionLockNumber}
        </div>
        <div className="whitespace-pre-line leading-4 text-white md:text-4xl">
          {helpSectionLockStats}
        </div>
      </div>
    </div>
  )
}

const GirlPhoneImage = () => (
  <StaticImage
    objectFit="cover"
    objectPosition="center"
    src="../../../images/AdobeStock_277750441.jpeg"
    alt=""
    style={{ display: "contents" }}
  />
)

const Text = ({ className = "", children }) => (
  <p
    className={cc([
      "m-0 whitespace-pre-line text-left font-display text-2xl text-zinc-800 sm:text-2xl",
      className,
    ])}
  >
    {children}
  </p>
)

export default function StatsGirl() {
  const { helpSectionListTitle, helpSectionListItems } = useTranslations()

  return (
    <Divided Image={GirlPhoneImage} theme="light" reversed>
      <div className="space-y-6">
        <Text>{helpSectionListTitle}</Text>
        <div className="relative lg:order-1">
          <List
            items={helpSectionListItems.map((item, index) => ({
              title: item,
              id: index,
            }))}
            bullet={<IconCheckmark width="30" />}
            textStyle="dark"
          />
        </div>
      </div>
    </Divided>
  )
}
